import { createWebSocketRequest } from './utils';

/**
 * Create a categories object from an array of category names
 * @param {Array<string>} categoryNames - Array of category name strings
 * @returns {Object} - Object with category names as keys and empty arrays as values
 */
function createCategoriesFromNames(categoryNames) {
  const result = {};
  
  // Track the original tabs from the response
  const originalTabs = [];
  
  // Convert each category name to lowercase and create an empty array for instruments
  categoryNames.forEach(name => {
    if (name && typeof name === 'string') {
      const categoryName = name.toLowerCase();
      result[categoryName] = []; // Empty array for instruments
      originalTabs.push(categoryName); // Add to our list of tabs from the server
    }
  });
  
  // Ensure we have at least the basic categories, even if not returned by the server
  // This ensures the category data exists, but doesn't mean we'll show these tabs
  const requiredCategories = ['forex', 'cfd', 'stocks', 'watchlist', 'crypto'];
  requiredCategories.forEach(category => {
    if (!result[category]) {
      result[category] = [];
    }
  });
  
  // Create tabs array starting with only the categories that came from the server
  let tabs = [...originalTabs];
  
  // Always include 'watchlist' in tabs
  if (!tabs.includes('watchlist')) {
    tabs.push('watchlist');
  }
  
  // Add the tabs property to the result
  result.tabs = tabs;
  
  return result;
}

/**
 * Get all instrument categories with their instruments
 * @returns {Promise<Object>} A promise that resolves with the instrument categories data
 */
export const getAllCategories = () => {
  return createWebSocketRequest({
    eventName: 'all-categories',
    requestType: 'get-all-category',
    dataValidator: (data) => {
      if (data.data && Array.isArray(data.data)) {
        // Create category objects from the array of names
        return createCategoriesFromNames(data.data);
      }
      return undefined;
    },
    errorMessage: 'Timeout waiting for categories'
  });
}; 